import { Injectable, inject } from '@angular/core';
import { EditDialogData } from './interfaces';
import { DialogService } from '@core/services/dialog.service';
import { EditDialogComponent } from './edit-dialog.component';
import { DvDialogComponent } from '@devinco/ui/dds';

@Injectable({ providedIn: 'root' })
export class EditDialogService {
  private dialog = inject(DialogService);

  /**
   * @param {EditDialogData<T>} dialogData
   * @param {'sm' | 'md' | 'lg' | 'xl' | 'full'} size - dialog size. Default md
   * */
  openEditDialog<TEntity>(
    dialogData: EditDialogData<TEntity>
  ): DvDialogComponent<EditDialogData<TEntity>, EditDialogComponent<TEntity>> {
    return this.dialog.open<
      EditDialogData<TEntity>,
      EditDialogComponent<TEntity>
    >({
      contentComponent: EditDialogComponent,
      ...dialogData,
      data: dialogData,
      hideFooter: true,
    });
  }
}
